import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabaseClient';
import { useAuth } from '@/contexts/AuthContext';

export type UserType = 'standard' | 'co_branded' | 'white_label' | 'partner_client';

export function useUserType() {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['user-type', user?.id],
    queryFn: async (): Promise<UserType | null> => {
      if (!user) return null;
      
      const { data, error } = await supabase
        .from('profiles')
        .select('user_type')
        .eq('user_id', user.id)
        .single();
        
      if (error) {
        console.error('Failed to fetch user type:', error);
        return null;
      }
      
      return data?.user_type || 'standard';
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useIsWhiteLabelPartner() {
  const { data: userType } = useUserType();
  return userType === 'white_label';
}